import {
    Component,
    Material,
    Mesh,
    MeshComponent,
    RetainEmitter,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

export interface MeshComponentProps {
    mesh: Mesh | null;
    material: Material | null;
}

export interface Character {
    name: string;
    level: number;
    price: number;
    body?: MeshComponentProps[];
    head?: MeshComponentProps[];
}

export const CHARACTERS = new Map<string, Character>();
export const onCharactersReady = new RetainEmitter();
CHARACTERS.set('Dummy', {name: 'dummy', level: 0, price: 0});

/**
 * register-character
 */
export class RegisterCharacter extends Component {
    static TypeName = 'register-character';

    @property.string('dummy')
    name = 'dummy';

    @property.int(0)
    level = 0;

    @property.int(0)
    price = 0;

    start() {
        const body = this.object;
        const head = this.object.children[0];

        CHARACTERS.set(this.name, {
            name: this.name,
            level: this.level,
            price: this.price,
            body: body
                .getComponents(MeshComponent)
                .map((c) => ({mesh: c.mesh, material: c.material})),
            head: head
                .getComponents(MeshComponent)
                .map((c) => ({mesh: c.mesh, material: c.material})),
        });

        setTimeout(() => this.object.destroy(), 0);
    }
}

export class CharacterLibrary extends Component {
    static TypeName = 'character-library';
    start() {
        this.engine.scene.append('CharacterLibrary.bin').then(() => {
            onCharactersReady.notify();
        });
    }

    onDestroy(): void {
        onCharactersReady.reset();
        CHARACTERS.clear();
    }
}
